import React from "react";
import {
  location,
  mission,
  whoWeAre,
  whyAccessCV,
} from "../lib/aboutUsContent";
import { Link } from "react-router";
import founder from "../assets/founder.jpeg";
export default function AboutUs() {
  return (
    <div className="flex-1">
      <section className="flex w-full justify-center bg-primaryColor p-10 text-white sm:p-14 md:p-20 lg:p-32 xl:p-36">
        <div className="flex flex-col gap-4 md:gap-6">
          <h2 className="text-lg font-bold text-secondaryColor md:text-2xl lg:text-4xl">
            {mission?.title}
          </h2>
          <h3 className="text-sm md:text-lg lg:text-xl">{mission?.subtitle}</h3>
          <p className="text-sm md:text-lg lg:text-xl">{mission?.body}</p>
        </div>
      </section>
      <section className="flex w-full justify-center p-10 sm:p-14 md:p-20 lg:p-32 xl:p-36">
        <div className="flex w-full flex-col items-center gap-4 md:gap-6 lg:flex-row lg:gap-10 xl:gap-14">
          <div className="lg:flex lg:w-1/4 lg:flex-col lg:items-start lg:gap-4">
            <h2 className="text-center text-lg font-bold text-primaryColor md:text-xl lg:text-left lg:text-3xl">
              {whoWeAre?.title}
            </h2>
            <Link
              to={whoWeAre?.cta?.url}
              className="hidden w-fit rounded-3xl bg-primaryColor px-5 py-3 text-center text-base font-bold text-secondaryColor shadow-md transition-all hover:bg-primaryHover hover:shadow-lg focus:bg-primaryHover focus:shadow-none active:bg-primaryHover active:shadow-none lg:block xl:px-8 xl:py-4 xl:text-lg"
            >
              {whoWeAre?.cta?.text}
            </Link>
          </div>
          <p className="text-sm md:text-base lg:w-2/3 lg:text-xl">
            {whoWeAre?.body}
          </p>
          <img
            src={founder}
            alt="Photograph of the founder of Access CV"
            className="w-1/2 md:w-1/3 lg:w-1/12"
          />
          <Link
            to={whoWeAre?.cta?.url}
            className="rounded-3xl bg-primaryColor px-4 py-2 text-sm font-bold text-secondaryColor shadow-md transition-all focus:bg-primaryHover focus:shadow-none active:bg-primaryHover active:shadow-none md:py-3 md:text-base lg:hidden"
          >
            {whoWeAre?.cta?.text}
          </Link>
        </div>
      </section>
      <section className="flex flex-col items-center justify-center gap-6 bg-gray-200 p-10 sm:p-14 md:p-20 lg:flex-row lg:gap-24 lg:p-32 xl:p-36">
        <div className="w-full text-center lg:w-1/4 lg:p-8 lg:text-left">
          <h2 className="text-lg font-bold text-primaryColor md:text-2xl lg:mb-6 xl:text-3xl">
            {whyAccessCV?.title}
          </h2>
          <p className="text-base md:text-lg lg:text-xl">
            {whyAccessCV?.subtitle}
          </p>
        </div>
        <ul className="flex w-full flex-col gap-4 lg:w-3/4 lg:flex-row lg:flex-wrap lg:justify-evenly lg:gap-6 xl:gap-10">
          {whyAccessCV?.content?.map((item, index) => {
            return (
              <li key={index} className="w-full lg:w-5/12">
                <h3 className="mb-2 text-lg text-primaryColor md:mb-3 md:text-xl lg:mb-4 lg:text-2xl">
                  {item.title}
                </h3>
                <p className="text-base md:text-lg lg:text-xl">{item.body}</p>
              </li>
            );
          })}
        </ul>
      </section>
      <section className="flex flex-col items-center justify-center gap-6 p-10 sm:p-14 md:p-20 lg:flex-row lg:gap-24 lg:p-32 xl:p-36">
        <iframe
          className="h-[30vh] w-full lg:h-[45vh] lg:w-1/2"
          loading="lazy"
          allowFullScreen
          src="https://www.google.com/maps/embed/v1/place?q=place_id:ChIJw1-YkGOTfkgRX6yyig7FawM&key=AIzaSyBprCx959hjug30klzzuPOCWH-muxUyQ6k"
        ></iframe>
        <p className="text-sm md:text-base lg:w-1/2 lg:text-xl">
          {location?.body}
        </p>
      </section>
    </div>
  );
}
